import { t } from 'ttag';

import { useInfinityScroll } from '@hook/useInfinityScroll';
import { Title } from '@ui/Title';
import {
  UserReview,
  Review,
} from '@components/UserReview';

import s from './UserReviewsFeed.sss';

export interface ReviewFeed extends Review {
  id: number,
}

interface Props {
  reviews?: ReviewFeed[],
  className?: string,
  onLoadMore?(): void,
}

const scrollRangeToFetchMore = 1500;

export const UserReviewsFeed: React.FC<Props> = ({
  reviews = [],
  onLoadMore = () => undefined,
  className,
}) => {
  const ref = useInfinityScroll(onLoadMore, scrollRangeToFetchMore);

  return (
    (
      <div ref={ref} className={className}>
        {!reviews.length && (
        <Title
          className={s.empty}
          type="h5"
          bold={false}
        >
          {t`Тут поки пусто`}
        </Title>
        )}
        {reviews.map(
          (review) => (
            <UserReview
              className={s.review}
              key={review.id}
              review={review}
            />
          ),
        )}
      </div>
    )
  );
};
